import type { ComponentProps, FC } from "react";

import styled, { css } from "styled-components";

import { AIButton } from "@similarweb/ai-kit";
import { colorsPalettes, truncateText } from "@similarweb/styles";
import { Button, ButtonLabel } from "@similarweb/ui-components";

import { withSWReactIconFillColor } from "app/pages/sales-intelligence/common-components/styles";

const INACTIVE_BUTTON_COLOR = colorsPalettes.midnight[200];
const INACTIVE_BUTTON_HOVER_COLOR = colorsPalettes.midnight[400];

type PointerEventsProps = {
    withPointerEvents: boolean;
};

const pointerEventsStyles = ({ withPointerEvents }: PointerEventsProps) => css`
    pointer-events: ${withPointerEvents ? "auto" : "none"};
`;

const fullWidthShrinkableStyles = css`
    width: 100%;
    min-width: 0;
    max-width: 100%;
`;

type StyledButtonProps<ButtonProps> = ButtonProps & PointerEventsProps;

export const StyledFilterModeButton = styled<FC<StyledButtonProps<ComponentProps<typeof Button>>>>(Button)`
    ${pointerEventsStyles};
    ${fullWidthShrinkableStyles};

    ${ButtonLabel} {
        ${truncateText()};

        display: inline;
    }

    ${({ type }) => {
        if (type === "flatDark") {
            return css`
                &:hover {
                    background-color: transparent;
                }

                ${ButtonLabel} {
                    color: ${INACTIVE_BUTTON_COLOR};

                    &:hover {
                        color: ${INACTIVE_BUTTON_HOVER_COLOR};
                    }
                }
            `;
        }
    }};
`;

export const StyledAiFilterModeButton = styled<FC<StyledButtonProps<ComponentProps<typeof AIButton>>>>(AIButton)`
    ${pointerEventsStyles};
    ${fullWidthShrinkableStyles};

    & > span {
        ${truncateText()};
    }

    ${({ variant }) => {
        if (variant === "flat") {
            return css`
                color: ${INACTIVE_BUTTON_COLOR};

                ${withSWReactIconFillColor("currentColor")};

                & > span {
                    color: currentcolor;
                }

                &:hover {
                    color: ${INACTIVE_BUTTON_HOVER_COLOR};

                    ${withSWReactIconFillColor("currentColor")};

                    & > span {
                        color: currentcolor;
                    }

                    &:before {
                        background: transparent;
                    }
                }
            `;
        }
    }};
`;
